import axios from './axios'

export default async () => await axios('getme')